<template>
    <div class="reset" :style="{ backgroundImage: `url(${require('../assets/images/grafokettbakgrundsbild2.png')})` }">
        <login-box class="w-1/2 m-auto bg-primary rounded mt-64" style="height: 480px;">
            <template v-slot:header>
                <p class="pt-20 text-lg">Reset your password</p>
            </template>
            <template>
                <v-input class="pt-4" ref="enterEmail" :error="showErrorMessage(errorMessage)" :labelPlaceholder="'Enter email'" :type="'text'" v-model="email" />
                <v-input class="pt-4" ref="enterPasswordInput" :showPassword="true" :error="passwordRulesError || showErrorMessage(errorMessage)" :labelPlaceholder="'Enter password'" :type="'password'" v-model="enterPassword" />
                <v-input class="pt-4" ref="passwordInput" :showPassword="true" :error="matchError || showErrorMessage(errorMessage)" :labelPlaceholder="'Confirm password'" :type="'password'" v-model="password" />
                <password-rules-hint class="pt-2" />

                <div class="text-center pt-16" >
                    <grafokett-button :class="{ disable: !canSubmit || loginStatus === 'loading' }" :disabled="!canSubmit || loginStatus === 'loading'" class="primary pt-4 focus:border-white  " @click="updatePassword" :error="this.message">Update password</grafokett-button>
                </div>
            </template>
        </login-box>
        <Loading v-if="loginStatus === 'loading'" :heading="'Done!'" :description="'Your password has now been reset. You will now be re-directed to the login page.'" />
    </div>
</template>

<script>
import vInput from "components/forms/Input.vue"
import GrafokettButton from "components/forms/Button.vue"
import LoginBox from "../components/LoginBox.vue"
import Loading from "../components/Loading"
import PasswordRulesHint from "../components/PasswordRulesHint.vue"
import { validatePassword } from "../utils/passwordRules"

export default {
    name: 'resetpassword',
    components: {
        vInput,
        GrafokettButton,
        LoginBox,
        Loading,
        PasswordRulesHint
    },
    data() {
        return {
            password: '',
            enterPassword: '',
            email: '',
            message: '',
            token: ''
        }
  },
  methods: {
    showErrorMessage (error) {
				if(!error) return
				if(error.status === 422) return error.data
				return error.data.message
        },
    updatePassword () {
        if (this.$store.getters['AUTH/AUTH_STATUS'] === 'loading') return
        if (!this.canSubmit) return
        this.message = ''
        const payload = {
            email: this.email,
            newPassword: this.password,
            passwordResetToken: this.token
        }
        this.$store.dispatch('AUTH/UPDATE_PASSWORD', payload).then(() => {
            this.$router.push({ name: 'login' })
        })
        .catch(err => {
            console.warn('login error', err)
        })
    },
  },
  computed: {
    errorMessage () {
      return this.$store.getters['AUTH/ERROR_MESSAGE']
    },
    loginStatus () {
      return this.$store.getters['AUTH/AUTH_STATUS']
    },
    passwordRulesError () {
      if (!this.enterPassword) return null
      const result = validatePassword(this.enterPassword)
      return result.valid ? null : result.message
    },
    matchError () {
      if (!this.password || !this.enterPassword) return null
      return this.password !== this.enterPassword
        ? 'The passwords do not match. Please re-enter the password.'
        : null
    },
    canSubmit () {
      if (!this.enterPassword || !this.password) return false
      if (this.enterPassword !== this.password) return false
      return validatePassword(this.enterPassword).valid
    }
  },
  mounted () {
    const token = this.$route.query['token']
    this.token = token
  }
}
</script>

<style lang="postcss">
   .reset {
    min-height: calc(100vh - theme('variables.header-size') * 2);
    @apply relative min-w-full bg-cover bg-center;
   }
</style>
